module.exports = __webpack_public_path__ + "static/img/bg-id-card-back.82d5c3e9.png";